import { render } from "./ClientAccount.vue?vue&type=template&id=65029b29&scoped=true"
import script from "./ClientAccount.vue?vue&type=script&lang=js"
export * from "./ClientAccount.vue?vue&type=script&lang=js"

import "./ClientAccount.vue?vue&type=style&index=0&id=65029b29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65029b29"]])

export default __exports__